/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillItem } from './BillItem';
import {
    BillItemFromJSON,
    BillItemFromJSONTyped,
    BillItemToJSON,
    BillItemToJSONTyped,
} from './BillItem';
import type { EnumItem5 } from './EnumItem5';
import {
    EnumItem5FromJSON,
    EnumItem5FromJSONTyped,
    EnumItem5ToJSON,
    EnumItem5ToJSONTyped,
} from './EnumItem5';

/**
 * 
 * @export
 * @interface BillListVo
 */
export interface BillListVo {
    /**
     * 当前页
     * @type {number}
     * @memberof BillListVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof BillListVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof BillListVo
     */
    totalRecord?: number;
    /**
     * 账单记录列表
     * @type {Array<BillItem>}
     * @memberof BillListVo
     */
    records?: Array<BillItem>;
    /**
     * 账单类型列表
     * @type {Array<EnumItem5>}
     * @memberof BillListVo
     */
    billTypeList?: Array<EnumItem5>;
    /**
     * 卡类型列表
     * @type {Array<EnumItem5>}
     * @memberof BillListVo
     */
    cardTypeList?: Array<EnumItem5>;
    /**
     * 账单状态列表
     * @type {Array<EnumItem5>}
     * @memberof BillListVo
     */
    statusList?: Array<EnumItem5>;
}

/**
 * Check if a given object implements the BillListVo interface.
 */
export function instanceOfBillListVo(value: object): value is BillListVo {
    return true;
}

export function BillListVoFromJSON(json: any): BillListVo {
    return BillListVoFromJSONTyped(json, false);
}

export function BillListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(BillItemFromJSON)),
        'billTypeList': json['billTypeList'] == null ? undefined : ((json['billTypeList'] as Array<any>).map(EnumItem5FromJSON)),
        'cardTypeList': json['cardTypeList'] == null ? undefined : ((json['cardTypeList'] as Array<any>).map(EnumItem5FromJSON)),
        'statusList': json['statusList'] == null ? undefined : ((json['statusList'] as Array<any>).map(EnumItem5FromJSON)),
    };
}

export function BillListVoToJSON(json: any): BillListVo {
    return BillListVoToJSONTyped(json, false);
}

export function BillListVoToJSONTyped(value?: BillListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(BillItemToJSON)),
        'billTypeList': value['billTypeList'] == null ? undefined : ((value['billTypeList'] as Array<any>).map(EnumItem5ToJSON)),
        'cardTypeList': value['cardTypeList'] == null ? undefined : ((value['cardTypeList'] as Array<any>).map(EnumItem5ToJSON)),
        'statusList': value['statusList'] == null ? undefined : ((value['statusList'] as Array<any>).map(EnumItem5ToJSON)),
    };
}

